<template>
  <div class="field-container">
    <b-row
      v-for="(condition, conditionIndex) in field.conditions"
      :key="`${field.fieldForm.field}-${conditionIndex}`"
      class="condition-row"
    >
      <b-col md="10">
        <b-form-group>
          <b-input-group>
            <b-row class="w-100">
              <b-col cols="2">
                <label class="pl-1">Kezdő Év</label>
                <b-form-input
                  placeholder="Kezdő Év"
                  class="border inputFieldAlign"
                  :min="field.fieldForm.type.min"
                  :max="field.fieldForm.type.max"
                  :value="condition.startYear"
                  type="number"
                  @change="onValueChanged($event, 'startYear', conditionIndex)"
                >
                </b-form-input>
              </b-col>
              <b-col cols="2">
                <label class="pl-1">Befejező Év</label>
                <b-form-input
                  placeholder="Befejező Év"
                  class="border inputFieldAlign"
                  :min="field.fieldForm.type.min"
                  :max="field.fieldForm.type.max"
                  :value="condition.lastYear"
                  type="number"
                  @change="onValueChanged($event, 'lastYear', conditionIndex)"
                >
                </b-form-input>
              </b-col>
              <b-col cols="4">
                <label class="pl-1">Reláció</label>
                <b-dropdown
                  :text="convertOperatorToReadable(condition.operator)"
                  class="condition-dropdown dropdown-competition"
                  :disabled="field.fieldForm.allowedOperators.length === 1"
                >
                  <b-dropdown-item
                    v-for="(operator, dropdownItemIndex) in field.fieldForm.allowedOperators"
                    @click="onValueChanged(operator.action, 'operator', conditionIndex)"
                    :key="`${field.fieldForm.field}-${dropdownItemIndex}`"
                    >{{ convertOperatorToReadable(operator.action) }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-col>
              <b-col cols="4">
                <label class="pl-1">Átlagos százalékos növekedés</label>
                <b-form-input
                  placeholder="Átlagos százalékos növekedés"
                  class="border inputFieldAlign"
                  :min="field.fieldForm.type.min"
                  :max="field.fieldForm.type.max"
                  :value="condition.percentage"
                  type="number"
                  @change="onValueChanged($event, 'percentage', conditionIndex)"
                >
                </b-form-input>
              </b-col>
            </b-row>
          </b-input-group>
        </b-form-group>
        <company-field-errors
          v-if="getError(conditionIndex).length > 0"
          :errors="getError(conditionIndex)"
          :innerKey="`condition-${conditionIndex}-error-`"
        />
      </b-col>
      <b-col md="2" class="pt-4"
        ><span class="delete-text" @click="onDeleteClicked(conditionIndex)"> <delete-field :hasPadding="true"/></span>
      </b-col>
    </b-row>
    <b-row
      v-if="field.fieldForm.allowedOperators.length !== field.conditions.length"
      class="add-filter"
      @click="onAddFilterClicked"
      md="12"
    >
      <add-new-field />
    </b-row>
  </div>
</template>
<script>
import { getReadableOperator } from '../../models/operator'
import CompanyFieldErrors from './CompanyFieldErrors.vue'
import AddNewField from './AddNewField.vue'
import DeleteField from './DeleteField.vue'
export default {
  name: 'SpecialFinanceDataField',
  props: ['field', 'onChanged', 'getFieldFormErrors', 'onDelete'],
  components: { CompanyFieldErrors, AddNewField, DeleteField },
  computed: {
    conditions: function() {
      return this.field.conditions
    },
    operators: function() {
      const result = this.field.allowedOperators.map(allowedOperator => ({
        value: allowedOperator.action,
        name: getReadableOperator(allowedOperator.action)
      }))
      return result
    }
  },
  methods: {
    onFieldChanged: function(updatedField, conditionIndex) {
      this.onChanged(updatedField, conditionIndex)
    },
    getError: function(conditionIndex) {
      return this.getFieldFormErrors({ key: this.field.fieldForm.field, index: conditionIndex })
    },
    onValueChanged: function(value, key, index) {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions[index] = { ...updatedField.conditions[index] }
      updatedField.conditions[index][key] = value
      this.onFieldChanged(updatedField, index)
    },
    onAddFilterClicked: function() {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions.push({
        startYear: '',
        lastYear: '',
        operator: this.field.fieldForm.allowedOperators[0].action,
        percentage: ''
      })
      this.onFieldChanged(updatedField)
    },
    onDeleteClicked: function(index) {
      const updatedField = { ...this.field }
      updatedField.conditions = [...updatedField.conditions]
      updatedField.conditions.splice(index, 1)
      this.onFieldChanged(updatedField, index)
    },
    convertOperatorToReadable: function(operator) {
      const friendlyNameOfAction = this.field.fieldForm.allowedOperators.filter(op => op.action === operator)[0]
        .friendlyNameOfAction
      if (friendlyNameOfAction !== undefined) {
        return friendlyNameOfAction
      } else {
        return getReadableOperator(operator)
      }
    }
  }
}
</script>
<style></style>
